import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseSelectFormFieldComponent } from '@shared/form-fields/select/base-select-form-field.component';
import type { FixedRate } from '@shared/modules/fixed-rates/fixed-rate';

@Component({
    selector: 'app-fixed-rates-select',
    templateUrl: '../../../form-fields/select/select-form-field.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FixedRatesSelectComponent), multi: true },
        CurrencyPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FixedRatesSelectComponent extends BaseSelectFormFieldComponent<FixedRate> {

    @Input() set fixedRates(value: FixedRate[]) {
        const current = this.value;

        // Check if the new list contains the current value, if not, clear the value
        if (!value.find(f => f.id === current?.id)) {
            this.clear();
        }

        this.options = (value ?? []).map(fixedRate => ({
            value: fixedRate,
            label: fixedRate.name,
            description: this.currencyPipe.transform(fixedRate.amount / 100)
        }));
    }

    constructor(
        public element: ElementRef,
        public renderer: Renderer2,
        private currencyPipe: CurrencyPipe
    ) {
        super(element, renderer);
    }
}
